/**
 * Breadcrumbs UI component
 * @param  data 
 * @returns 
 * data : Array
 * breadcrumb : Array
 * breadcrumb.url : string
 * breadcrumb.text : string
 * 
 */ 
import React from "react"
//import { Link } from "gatsby"
function Breadcrumbs(data) {
    const breadcrumbs = data.breadcrumbData.map((breadcrumb, index) => {
        /**
         * Need to remove "publications" if it is in the url as does not follow yoast seo setting
         */
        if(breadcrumb.url !== "/publications/"){
            return (
                <li className="breadcrumbs__linkitem" key={index}>
                   {/** <Link to={breadcrumb.url}><span dangerouslySetInnerHTML={{__html: breadcrumb.text}}/></Link> **/}
                    <a href={breadcrumb.url}><span dangerouslySetInnerHTML={{__html: breadcrumb.text}}/></a>
                </li>
            )
        } else {
            return null;
        }
        
    });
    return(
        <div className="page-breadcrumbs">
            <ul className="breadcrumbs">
                {breadcrumbs} 
            </ul>
        </div>
    )
}
export default Breadcrumbs